"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
const logos = [{
  id: 1,
  name: "University of Florida",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/logo_uf.png"
}, {
  id: 2,
  name: "University of Washington",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/logo_uw.png"
}, {
  id: 3,
  name: "American College of Prosthodontists",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/logo_acp.png"
}, {
  id: 4,
  name: "American Academy of Esthetic Dentistry",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/logo_aaed.png"
}, {
  id: 5,
  name: "American Board of Prosthodontics",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/logo_abp.png"
}, {
  id: 6,
  name: "International College of Prosthodontists",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/logo_icp.png"
}, {
  id: 7,
  name: "Florida Prosthodontic Association",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/logo_fpa.png"
}, {
  id: 8,
  name: "Academy of Osseointegration",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/logo_ao.png"
}];
export default function Collaborators() {
  const duplicatedLogos = [...logos, ...logos];
  return <section data-section-id="121694" id="academic-affiliations" className="bg-[#FFFFFF] text-[#000000] py-20 overflow-hidden flex flex-col justify-center">
      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-ticker {
          animation: ticker 40s linear infinite;
        }
        .animate-ticker:hover {
          animation-play-state: paused;
        }
      `}</style>
      
      <div className="container mx-auto px-4 md:px-8 mb-10">
        <Separator className="w-full bg-[#DDDDDD]" />
      </div>

      <div className="relative flex overflow-hidden w-full py-4">
        {}
        <div className="absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-[#FFFFFF] to-transparent z-10 pointer-events-none"></div>
        <div className="absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-[#FFFFFF] to-transparent z-10 pointer-events-none"></div>
        
        <div className="flex w-max animate-ticker items-center">
          {duplicatedLogos.map((logo, i) => <div key={`${logo.id}-${i}`} data-index={i} className="flex-shrink-0 px-12 md:px-24 flex items-center justify-center">
              <img src={logo.src} alt={logo.name} className="h-8 md:h-10 lg:h-12 w-auto object-contain grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-500 cursor-pointer" />
            </div>)}
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-8 mt-10">
        <Separator className="w-full bg-[#DDDDDD]" />
      </div>
    </section>;
}